import { useEffect, useState, useCallback } from "react";
import { Loader2, CheckCircle2, XCircle, Wallet } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { rupiah, fmtDateTime } from "@/lib/format";

function CreditHoldCard({ o, onDone }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(null);
  const h = o.credit_hold || {};
  const decide = async (kind) => {
    if (kind === "reject" && note.trim().length < 3) { toast.error("Isi alasan penolakan (minimal 3 karakter)"); return; }
    if (kind === "reject" && !window.confirm(`Tolak ${o.so_number}? Order akan dibatalkan (Void).`)) return;
    setBusy(kind);
    try {
      const res = await api.post(`/sales/${o.id}/credit-${kind}`, { note: note.trim() || null });
      toast.success(kind === "approve" ? `${res.data.data.so_number} disetujui — bisa diproses` : `${o.so_number} ditolak & dibatalkan`);
      if (res.data.meta?.odoo_warning) toast.warning(res.data.meta.odoo_warning);
      onDone();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(null); }
  };
  return (
    <div className="panel approval-card credit-hold-card" data-testid={`credit-hold-${o.so_number}`}>
      <div className="approval-main">
        <div className="store-icon credit"><Wallet /></div>
        <div><strong>{o.outlet}</strong><span>{o.so_number} · {o.owner_name}</span>
          <span className="bill-chip credit-hold void-req-status">Melewati batas kredit</span></div>
      </div>
      <div className="void-req-body">
        <div className="credit-hold-grid" data-testid={`credit-hold-numbers-${o.so_number}`}>
          <div><span>Batas kredit</span><b>{rupiah(h.credit_limit)}</b></div>
          <div><span>Piutang berjalan</span><b>{rupiah(h.ar_outstanding)}</b></div>
          <div><span>Order belum ditagih</span><b>{rupiah(h.unbilled_orders)}</b></div>
          <div><span>Order ini</span><b>{rupiah(h.order_amount)}</b></div>
          <div className="bad"><span>Total setelah order</span><b>{rupiah(h.exposure_after)}</b><small>lebih {rupiah(h.over_by)}</small></div>
        </div>
        <small>Dibuat {fmtDateTime(o.created_at)}</small>
        <input className="rj-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Catatan (wajib jika menolak)" data-testid={`credit-note-${o.so_number}`} />
      </div>
      <div className="approval-actions">
        <button className="rj-btn rj-btn-green" onClick={() => decide("approve")} disabled={!!busy} data-testid={`credit-approve-${o.so_number}`}>
          {busy === "approve" ? <Loader2 size={16} className="spin" /> : <><CheckCircle2 size={16} /> Setujui</>}
        </button>
        <button className="rj-btn rj-btn-ghost" onClick={() => decide("reject")} disabled={!!busy} data-testid={`credit-reject-${o.so_number}`}>
          {busy === "reject" ? <Loader2 size={16} className="spin" /> : <><XCircle size={16} /> Tolak</>}
        </button>
      </div>
    </div>
  );
}

export function CreditApprovals({ refreshKey, onChanged }) {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => {
    api.get("/credit-approvals").then((r) => setRows(r.data.data)).catch((e) => { toast.error(apiError(e)); setRows([]); });
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);
  const done = () => { load(); onChanged?.(); };

  return (
    <div data-testid="credit-approvals-tab">
      <p className="fin-hint credit-tab-hint">Order yang membuat total tagihan customer melewati batas kredit tertahan di sini. Setujui agar order dikirim ke Odoo & bisa diproses, atau tolak (wajib alasan) untuk membatalkannya.</p>
      {rows === null ? <div className="rj-loading"><Loader2 className="spin" /> Memuat…</div> : rows.length === 0 ? (
        <div className="panel rj-empty" data-testid="credit-approvals-empty"><CheckCircle2 /><p>Tidak ada order yang menunggu persetujuan kredit.</p></div>
      ) : (
        <div className="approval-list">{rows.map((o) => <CreditHoldCard key={o.id} o={o} onDone={done} />)}</div>
      )}
    </div>
  );
}
